"use client"

import { HelpCircle } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { useTranslation } from "@/hooks/use-translation"
import type { TranslationKey } from "@/lib/translations"

export function SourceFieldTooltip() {
  const { t } = useTranslation()

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <HelpCircle className="h-4 w-4 text-muted-foreground cursor-help" />
        </TooltipTrigger>
        <TooltipContent className="max-w-sm">
          <div className="space-y-3">
            <p className="font-bold">{t("sourceFieldHelp.tooltip.title")}</p>
            <div className="space-y-2 text-sm">
              <div>
                <p className="font-medium text-xs uppercase tracking-wide text-muted-foreground mb-1">{t("sourceFieldHelp.dotNotation.title")}</p>
                <p>{t("sourceFieldHelp.dotNotation.body")}</p>
                <p className="font-mono text-xs bg-muted px-2 py-1 rounded mt-1">candidate.firstName</p>
                <p className="font-mono text-xs bg-muted px-2 py-1 rounded">jobOrder.owner.email</p>
              </div>
              <div>
                <p className="font-medium text-xs uppercase tracking-wide text-muted-foreground mb-1">{t("sourceFieldHelp.arrayAccess.title")}</p>
                <p>{t("sourceFieldHelp.arrayAccess.body")}</p>
                <p className="text-xs text-muted-foreground mt-1">{t("sourceFieldHelp.arrayAccess.firstCategory")}</p>
                <p className="font-mono text-xs bg-muted px-2 py-1 rounded">categories[0].name</p>
                <p className="text-xs text-muted-foreground mt-1">{t("sourceFieldHelp.arrayAccess.firstName")}</p>
                <p className="font-mono text-xs bg-muted px-2 py-1 rounded">names[0]</p>
              </div>
              <div>
                <p className="font-medium text-xs uppercase tracking-wide text-muted-foreground mb-1">{t("sourceFieldHelp.important.title")}</p>
                <p className="text-destructive">{t("sourceFieldHelp.important.body")}</p>
              </div>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
} 